import { c as _c } from "react/compiler-runtime";
type TagProps = {
  text: string;
};
const Tag = t0 => {
  const $ = _c(3);
  const {
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-snippet-2 text-tertiary">#</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = <div className="flex items-center gap-1 py-0.5 px-1">{t1}<span className="text-snippet-2 text-primary">{text}</span></div>;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default Tag;